"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationIaBeatUtil = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
class ConfigurationIaBeatUtil {
    /**
     * Get the IA Beats of the given Configuration.
     * It will return the default one if no custom settings are available in IA or Kette.
     */
    static getConfigurationBeats(configuration) {
        var _a, _b;
        const kette = configuration.getKetteClone();
        const defaultBeatByKette = echain_shared_articles_oo_1.IaBeatUtil.getDefaultBeat(kette === null || kette === void 0 ? void 0 : kette.toModel());
        if (kette === null || kette === void 0 ? void 0 : kette.fixedIaBeat) {
            return [kette.fixedIaBeat];
        }
        if (configuration.iaArrangement === echain_shared_igus_fundamentals_1.IaArrangement.single) {
            const firstIa = configuration.getIAsClone().toArray().at(0);
            if (!firstIa)
                return [defaultBeatByKette];
            return [
                {
                    startingAt: firstIa.startingAtNthKettenglied || defaultBeatByKette.startingAt,
                    perNth: firstIa.perNthKettenglied || defaultBeatByKette.perNth,
                },
            ];
        }
        if (configuration.iaArrangement === echain_shared_igus_fundamentals_1.IaArrangement.evenOdd) {
            return echain_shared_articles_oo_1.IaBeatUtil.getEvenOddBeatsByKette(kette === null || kette === void 0 ? void 0 : kette.toModel());
        }
        if (configuration.iaArrangement === echain_shared_igus_fundamentals_1.IaArrangement.smartPlastics) {
            const ias = configuration.getIAsClone().toArray();
            const firstSecondBeatIA = ias.find((ia) => ia.startingAtNthKettenglied !== echain_shared_articles_oo_1.IaBeatUtil.getDefaultSmartPlasticBeats()[0].startingAt &&
                ia.perNthKettenglied !== echain_shared_articles_oo_1.IaBeatUtil.getDefaultSmartPlasticBeats()[0].perNth);
            if (firstSecondBeatIA) {
                return [
                    echain_shared_articles_oo_1.IaBeatUtil.getDefaultSmartPlasticBeats()[0],
                    {
                        startingAt: (_a = firstSecondBeatIA.startingAtNthKettenglied) !== null && _a !== void 0 ? _a : defaultBeatByKette.startingAt,
                        perNth: (_b = firstSecondBeatIA.perNthKettenglied) !== null && _b !== void 0 ? _b : defaultBeatByKette.perNth,
                    },
                ];
            }
            return echain_shared_articles_oo_1.IaBeatUtil.getDefaultSmartPlasticBeats();
        }
        throw new Error(`${this.className}.getConfigurationBeats() Invalid IaArrangement = ${configuration.iaArrangement}`);
    }
    /**
     * Retrieves the `IaBeat` for the current `userView` which may be defined for any kind of alternation.
     */
    static getBeatForUsersView(configuration, userView) {
        const beats = this.getConfigurationBeats(configuration);
        switch (userView) {
            case undefined:
            case 1:
                return beats[0];
            case 2:
                return beats[1];
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(userView);
        }
    }
}
exports.ConfigurationIaBeatUtil = ConfigurationIaBeatUtil;
ConfigurationIaBeatUtil.className = 'ConfigurationIaBeatUtil';
//# sourceMappingURL=ConfigurationIaBeatUtil.js.map